import React from 'react';
import LanguageSelector from "./LanguageSelector";
import {useSelector} from "react-redux";

const QuoteDetails = (props) => {
    const projectCreatedAt = useSelector(state => state.projectDetailsReducer.projectCreatedAt);
    const priceBook = useSelector(state => state.projectDetailsReducer.priceBook);
    const currency = useSelector(state => state.projectDetailsReducer.currency);
    const language = useSelector(state => state.projectDetailsReducer.language)

    const styles = {
        agencyDetailsLabel: {
            display: 'inline-block'
        },
        agencyDetails: {
            padding: '0 0 8px'
        },
        fieldWrapper: {
            marginLeft: '15px'
        }

    }
    
    let dateCreated = null;
    if(!props.newQuote) {
        dateCreated = (
            <div className='small-12 columns' style={styles.agencyDetails}>
                <label style={styles.agencyDetailsLabel}>Project Created:</label>
                <span>{projectCreatedAt}</span>
            </div>
        )
    }
    return (
        <div className="field-wrapper align-right" style={styles.fieldWrapper}>
            <div className='row'>
                {dateCreated}
                <div className='small-12 columns' style={styles.agencyDetails}>
                    <label style={styles.agencyDetailsLabel}>Currency: </label>
                    <span>{currency}</span>
                </div>
                <div className='small-12 columns' style={styles.agencyDetails}>
                    <label style={styles.agencyDetailsLabel}>Price Book:</label>
                    <span>{priceBook ? priceBook : "Needs Implementing"}</span>
                </div>
                <LanguageSelector languages={props.languages} newQuote={props.newQuote} readOnly={true} key={`selected-${language}`}/>
            </div>
        </div>
    )

}

export default QuoteDetails;